<template>
    <div class="practice-landing">
        <video-modal :open="videoModalOpen" @close="closeModal"></video-modal>
        <section class="section intro practice-section-1">
            <div id="p-c-div" class="container practice-cover-div">
                <div class="row">
                    <div class="col-md-5 text-sm-left">
                        <h1 class="m-t-0">Health Care Professional premier clinical solution</h1>
                        <p class="lead"><b>LogBox Practice uses the latest <br>technology to conveniently capture and <br>store patient data.
                            <br>
                            <span class="practice-lead-text-2">Improve patient care, record-keeping, case management and practice efficiency.</span>
                            </b>
                        </p>
                        <div>
                            <router-link to="/signup" class="btn practice-signup-button">Sign up</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section practice-section-2" v-once>
            <div class="container">
                <div class="row">
                    <div class="col-md-4 text-center">
                        <span class="section-feature-icons-two">
              <i class="fas fa-hands"></i>
            </span>
                        <h3>Patient Centric</h3>
                        <p>Enterprise-grade demographics capture
                            <br> and patient onboarding</p>
                    </div>
                    <div class="col-md-4 text-center">
                        <span class="section-feature-icons-two">
              <i class="fas fa-user-friends"></i>
            </span>
                        <h3>Clinical Collaboration</h3>
                        <p>Real-time clinical data sharing between
                            <br> multidisciplinary teams</p>
                    </div>
                    <div class="col-md-4 text-center">
                        <span class="section-feature-icons-two">
             <i class="fas fa-cloud-upload-alt"></i>
            </span>
                        <h3>Cloud Based</h3>
                        <p>High-performance web and mobile
                            <br> applications
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section practice-section-3 section-feature-background" v-once>
            <PracticeFeatures/>
        </section>
        <section class="section practice-section-4 practice-benefit-section" v-once>
            <div class="container">
                <div class="row">
                    <div class="col-sm-4 p-b-lg">
                        <ul class="feature-list fa-ul">
                            <li class="practice-benefits-title">
                                <h2 class="">LogBox benefits</h2></li>
                            <li class="practice-benefits-li">
                                <p>Avoid repetitive tasks and become
                                    <br/>digitally efficient</p>
                            </li>
                            <li class="practice-benefits-li">
                                <p>Profile completeness enforced by
                                    <br/>the system</p>
                            </li>
                            <li class="practice-benefits-li">
                                <p>Create seamless clinical workflows</p>
                            </li>
                            <li class="practice-benefits-li">
                                <p>Accuracy of Data entry</p>
                            </li>
                            <li class="practice-benefits-li">
                                <p>Save on printing costs</p>
                            </li>
                            <li class="practice-benefits-li">
                                <p>POPI compliance</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="section practice-section-5 section-feature-background white" v-once>
            <div class="container">
                <div class="row">
                    <h3>Learn More</h3>
                    <p>Sign up for a free trial</p>
                    <router-link to="/priceplans" class="btn practice-price-plan-btn">PLANS &amp; PRICING</router-link>
                </div>
            </div>
        </section>
        <section v-once>
            <div class="container-fluid">
                <div class="row flush">
                    <div class="col-md-4 grey-1">
                        <div class="p-a-lg">
                            <h3 class="m-t-0 m-b">LogBox Patient</h3>
                            <p class="">LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.</p>
                            <router-link to="/patient" class="btn practice-price-plan-btn">Learn More</router-link>
                        </div>
                    </div>
                    <div class="col-md-4 grey-2">
                        <div class="p-a-lg">
                            <h3 class="m-t-0 m-b">LogBox Practice</h3>
                            <p class="">Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.</p>
                            <router-link to="/signup" style="background-color:#14D3AB" class="btn">Sign Up Now</router-link>
                        </div>
                    </div>
                    <div class="col-md-4 grey-3">
                        <div class="p-a-lg">
                            <h3 class="m-t-0 m-b">LogBox Academic</h3>
                            <p class="">A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.</p>
                            <router-link to="/academic" class="btn practice-price-plan-btn">Learn More</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  import VideoModal from 'components/common/modals/VideoModal';
  import PartnerBranding from 'components/common/PartnerBranding';
  import PracticeFeatures from 'components/common/PracticeFeatures';
  import AppLinks from 'components/common/AppLinks';

  export default {
    name: 'practice',
    components: {
      VideoModal,
      PartnerBranding,
      PracticeFeatures,
      AppLinks,
    },
    data: () => ({
      videoModalOpen: false,
      links: {
        andriod: `${process.env.VUE_APP_PRACTICE_APP_ANDROID}`,
        apple: `${process.env.VUE_APP_PRACTICE_APP_ISO}`,
      },
    }),
    methods: {
      openModal() {
        this.videoModalOpen = true;
      },
      closeModal() {
        this.videoModalOpen = false;
      },
    },
    mounted() {
      this.$store.dispatch('updateContext', {
        context: 'practice',
      });
    },
  };

</script>
<style scoped>
  .practice-lead-text-2 {
    font-size: 18px;
  }

  .section-feature-icons-two {
    font-size:32pt;
    color: #14D3AB;
  }

  .section-feature-background {
    background-image: linear-gradient(49deg, rgb(20, 211, 171) 10%, rgb(0, 178, 179) 70%);
  }

  .practice-signup-button {
    background-color: #14D3AB;
    padding: 2% 8% 2% 8%;
  }

  .practice-benefits-title {
    padding-bottom: 2%;
  }
  .practice-benefits-li {
    border-bottom: 1px solid;
  }

  .practice-price-plan-btn {
    color: #14D3AB;
    background-color: white;
  }

  .practice-cover-div {
    padding:9% 0 24% 4%;
    color: black;
  }
  @media (max-width: 768px) {
    .practice-cover-div {
    color: white;
    }
  }
  .practice-section-1,
  .practice-section-2,
  .practice-section-3,
  .practice-section-4,
  .practice-section-5 {
    padding: 3%;
  }

</style>



// WEBPACK FOOTER //
// Practice.vue?2ac6b93c